var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{ref:"fzlogo",staticClass:"shrink",attrs:{"alt":"FlyZermatt Logo","contain":"","src":require("@/assets/FlyZermatt-logo-light.svg"),"transition":"scale-transition","max-width":"200","max-height":"130"},on:{"click":_vm.onClickedBtn}})
}
var staticRenderFns = []

export { render, staticRenderFns }